export enum ToastType {
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
}
